import React from 'react';

import { Field, FieldProps } from 'formik';
import { Translate } from 'react-localize-redux';

import TextField from '../../../../../ui/TextField/TextField';
import { countryCodeToCountry } from '../../banking.selectors';
import FormItemLayout from '../FormItemLayout';
import BankCountrySelectorFormField from './BankCountrySelectorFormField';
import FieldWrapper from './FieldWrapper';

const BankAddressFormFields = () => {
  const editView = window.location.pathname.endsWith('/edit');

  return (
    <FormItemLayout label={<Translate id="Bank_address" />}>
      <FieldWrapper>
        {!editView && (
          <BankCountrySelectorFormField
            name={'BankCountryCode'}
            fdKey={'Bank_address_country_code'}
          />
        )}
        {editView && (
          <Field name={'BankCountryCode'}>
            {({ field }: FieldProps) => {
              return (
                <TextField
                  defaultValue={countryCodeToCountry(field.value)}
                  fdKey={'Bank_address_country_code'}
                  label={<Translate id="Country" />}
                  fullWidth
                  InputProps={{ readOnly: true, disableUnderline: true }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              );
            }}
          </Field>
        )}
      </FieldWrapper>
    </FormItemLayout>
  );
};

export default BankAddressFormFields;
